const API_URL = process.env.REACT_APP_API_URL;
const APPLIXIR_API_KEY = '6e8b931d-42e8-456a-a807-9a64a78d62c0';

function getToken() {
  return localStorage.getItem('token');
}

export async function showRewardedAd() {
  const token = getToken();
  const checkRes = await fetch(`${API_URL}/videos/available`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  const availability = await checkRes.json();

  if (!availability.available) {
    throw new Error(
      availability.cooldownRemaining > 0
        ? `Espera ${availability.cooldownRemaining}s`
        : 'Límite diario alcanzado'
    );
  }

  await showApplixirAd();

  const rewardRes = await fetch(`${API_URL}/videos/reward`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ platform: 'web' })
  });

  if (!rewardRes.ok) {
    const err = await rewardRes.json();
    throw new Error(err.error || 'Error al reclamar recompensa');
  }

  return rewardRes.json();
}

function showApplixirAd() {
  return new Promise((resolve, reject) => {
    if (typeof window.initializeAndOpenPlayer !== 'function') {
      console.warn('Applixir SDK v6 no cargado, usando fallback');
      return fallbackAd().then(resolve).catch(reject);
    }

    let settled = false;
    const settle = (fn) => {
      if (settled) return;
      settled = true;
      fn();
    };

    const timeout = setTimeout(() => {
      console.warn('Applixir timeout, usando fallback');
      settle(() => fallbackAd().then(resolve).catch(reject));
    }, 30000);

    let adCompleted = false;

    const options = {
      apiKey: APPLIXIR_API_KEY,
      injectionElementId: 'applixir-video-container',
      adStatusCallbackFn: (status) => {
        console.log('Applixir status:', status.type);
        if (status.type === 'complete') {
          adCompleted = true;
        }
        if (status.type === 'allAdsCompleted' || status.type === 'thankYouModalClosed') {
          clearTimeout(timeout);
          if (adCompleted) {
            settle(() => resolve());
          } else {
            settle(() => reject(new Error('Video cancelado. Mirá el video completo para ganar monedas.')));
          }
        }
        if (status.type === 'skipped' || status.type === 'manuallyEnded' || status.type === 'consentDeclined') {
          clearTimeout(timeout);
          settle(() => reject(new Error('Video cancelado. Mirá el video completo para ganar monedas.')));
        }
      },
      adErrorCallbackFn: (error) => {
        clearTimeout(timeout);
        try {
          const errData = error.getError().data;
          console.warn('Applixir error:', errData.type, errData.errorMessage);
        } catch (e) {
          console.warn('Applixir error:', error);
        }
        settle(() => fallbackAd().then(resolve).catch(reject));
      }
    };

    try {
      window.initializeAndOpenPlayer(options);
    } catch (e) {
      clearTimeout(timeout);
      console.warn('Error invocando Applixir:', e);
      settle(() => fallbackAd().then(resolve).catch(reject));
    }
  });
}

function fallbackAd() {
  return new Promise((resolve) => {
    const overlay = document.createElement('div');
    Object.assign(overlay.style, {
      position: 'fixed', top: '0', left: '0', width: '100vw', height: '100vh',
      background: 'rgba(0,0,0,0.95)', zIndex: '99999',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
    });

    const icon = document.createElement('div');
    icon.textContent = '🎬';
    Object.assign(icon.style, { fontSize: '64px', marginBottom: '20px' });

    const timer = document.createElement('div');
    Object.assign(timer.style, {
      color: '#FFD700', fontSize: '24px', fontWeight: 'bold', fontFamily: 'Orbitron, monospace'
    });

    const sub = document.createElement('div');
    sub.textContent = 'Preparando tu recompensa...';
    Object.assign(sub.style, { color: '#aaa', fontSize: '14px', marginTop: '10px' });

    overlay.append(icon, timer, sub);
    document.body.appendChild(overlay);

    let seconds = 5;
    timer.textContent = seconds;

    const interval = setInterval(() => {
      seconds--;
      timer.textContent = seconds > 0 ? seconds : '✅';
      if (seconds <= 0) {
        clearInterval(interval);
        setTimeout(() => { overlay.remove(); resolve(); }, 500);
      }
    }, 1000);
  });
}

// Intersticial sin recompensa (solo monetización)
export async function showInterstitialAd() {
  await showApplixirAd();
}

export async function checkAvailability() {
  const token = getToken();
  const res = await fetch(`${API_URL}/videos/available`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  return res.json();
}
